
const initMatomo = () => {
    const matomoId = parseInt(document.body.dataset.matomoId, 10);

    if (!matomoId || isNaN(matomoId)) {
        console.warn('Matomo id is not set or invalid.');
        return;
    }

    const _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
        const u="https://wwwstats.brgm.fr/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', matomoId.toString()]);
        const d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
}

window.addEventListener('DOMContentLoaded', initMatomo);
document.addEventListener('turbo:load', initMatomo);